<div class="spinner-wrapper" *ngIf="visible">
  <p-progressSpinner></p-progressSpinner>
</div>